var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-wrapper"},[_c('vue-plyr',[_c('div',{staticClass:"plyr__video-embed"},[_c('iframe',{attrs:{"src":_vm.videoSrc,"loading":"lazy","allowfullscreen":"","allow":"autoplay","title":"video"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }